export default {
    name: 'donate',
}
